import type { ReactNode } from "react";
import { Container } from "@mui/material";
import MainSearch from "./components/MainSearch";

function HomePage(): ReactNode {
  return (
    <Container maxWidth="md">
      <MainSearch />
    </Container>
  );
}

export default HomePage;
